// Re-export all services maintaining backward compatibility
import { api } from './apiClient';
import { homeService } from './services/homeService';
import { authService } from './services/authService';
import { cartService } from './services/cartService';
import { paymentService } from './services/paymentService';
import { passService } from './services/passService';
import { countryService } from './services/countryService';
import { themeService } from './services/themeService';
import { searchService } from './services/searchService';
import { eventService } from './services/eventService';
import { registrationService } from './services/registrationService';
import { chatService } from './services/chatService';
import { whitelistService } from './services/whitelistService';
import { cacheService } from './services/cacheService';
import { addonService } from './services/addonService';
import { scannerService } from './services/scannerService';
import { organizationService } from './services/organizationService';

// Main API service object - maintains backward compatibility
export const apiService = {
  // Home page data
  getHomeData: homeService.getHomeData,

  // Authentication
  auth: authService,

  // Cart management
  cart: cartService,

  // Payment processing
  payment: paymentService,

  // Pass download
  passes: passService,

  // Country and currency
  country: countryService,

  // Theme management
  theme: themeService,

  // Search functionality
  search: searchService.search,
  getSearchSuggestions: searchService.getSearchSuggestions,

  // Events listing and detail
  events: eventService,

  // Event registration endpoints
  registration: registrationService,

  // Cache management utilities
  cache: cacheService,

  // Whitelist API
  whitelist: whitelistService,

  // Chat management
  chat: chatService,

  // Addon management
  addon: addonService,

  // Scanner management
  scanner: scannerService,

  // Organization microsite
  organization: organizationService,
};

// Export default axios instance for direct use if needed
export default api;
